import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#2E7D32",
        secondary: "#ff0164",
        accent: "#C62828",
        error: "#b71c1c",
      },
    },
  },
});
